<template>
  <SMBottomBar>
    <SMBottomBarItem v-for="(item, key) in options" :key="key" :icon="item.icon" @click="setLayout(item.layout)">
      {{ item.name }}
    </SMBottomBarItem>
  </SMBottomBar>
</template>
<script lang="ts">
import { mapActions } from 'vuex';
import INITIALLAYOUTS from '@/core/mode/layoutchooser/index';

export default {
  data() {
    const layouts = this.$app.props.options.layouts;
    const finalLayouts = INITIALLAYOUTS.filter((layout) => layouts.includes(layout.name));
    return {
      options: finalLayouts,
    };
  },
  created() {
    this.disableSelection();
  },
  beforeDestroy() {
    this.enableSelection();
  },
  methods: {
    ...mapActions('settings', ['setDrawingMode', 'changeLayout', 'disableSelection', 'enableSelection']),
    setLayout(layout) {
      this.changeLayout(layout);
      this.setDrawingMode();
    },
  },
};
</script>
